import type {
  V1alpha1KafkaCluster,
  V1alpha1KafkaClusterSpec,
  V1ObjectMeta
} from '@streamnative/cloud-api-client-typescript'

export interface KafkaClusterResourcePayload {
  organization: string
  instance: string
  name: string
  displayName?: string
  location: string
  poolMemberRef?: {
    namespace: string
    name: string
  }
  throughputUnit?: number
  isServerless?: boolean
  config?: {
    custom?: Record<string, string>
    lakehouseStorage?: {
      enabled: boolean
    }
  }
  clusterProfile?: string
  catalogs?: string[]
}

export const buildKafkaClusterPayload = (
  payload: KafkaClusterResourcePayload
): V1alpha1KafkaCluster => {
  const spec: V1alpha1KafkaClusterSpec & {
    throughputUnit?: number
    clusterProfile?: string
    catalogs?: string[]
  } = {
    instanceName: payload.instance,
    displayName: payload.displayName,
    location: payload.location,
    poolMemberRef: payload.poolMemberRef
  }

  if (!payload.isServerless) {
    spec.throughputUnit = payload.throughputUnit
    spec.config = payload.config
    spec.clusterProfile = payload.clusterProfile ?? 'latency-optimized'
    spec.catalogs = payload.catalogs ?? []
  }

  return {
    kind: 'KafkaCluster',
    metadata: {
      name: payload.name,
      namespace: payload.organization,
      annotations: {
        'cloud.streamnative.io/enable-schema-registry': 'true'
      }
    } as V1ObjectMeta,
    spec
  }
}
